import { defineStore } from 'pinia'
import { setSystemInfo as setSystemInfoStore, getSystemInfo } from '@/services/utils/auth'
import { API } from '@/services/api/main'
import request from '@/services/utils/request'

const useAppStore = defineStore('app', {
    state: () => ({
        systemInfo: getSystemInfo() || {},
        unreadCount: 0, // 未读消息数
        lastPlayed: {}, // 上次播放
        showLastPlayed: false, // 上次播放按钮显示
        learnRecord: {}, // 学习记录
        trainRecord: {}, // 培训记录
        playTime: 0 // 播放时间 或者 学习文档的进度
    }),
    actions: {
        // 设置系统信息
        setSystemInfo(systemInfo) {
            setSystemInfoStore(systemInfo)
            this.$patch({ systemInfo })
        },
        // 设置未读消息数
        setUnreadCount(count) {
            this.$patch({ unreadCount: count })
        },
        // 设置上次播放
        setLastPlayed(data) {
            this.$patch({ lastPlayed: data })
        },
        // 设置上次播放按钮
        setShowLastPlayed(bool) {
            this.$patch({ showLastPlayed: bool })
        },
        // 设置播放时长
        setPlayTime(data) {
            this.$patch({ playTime: data })
        },

        clearLearnRecord() {
            this.$patch({ learnRecord: null })
            console.log('>>>>>>>> 清空学习记录', JSON.stringify(this.learnRecord))
        },
        // 创建学习记录
        createLearnRecord({ courseId, courseLessonId, startTime }) {
            return new Promise((resolve, reject) => {
                request({
                    ...API.createMyStudyRecord,
                    data: {
                        courseId,
                        courseLessonId,
                        startTime: startTime || 0
                    }
                })
                    .then(async (data) => {
                        this.$patch({ learnRecord: data.data })
                        resolve()
                    })
                    .catch((error) => {
                        // 保留后端业务错误码，课程播放页需据此识别“学习前拍照”前置条件。
                        reject(error)
                    })
            })
        },
        // 更新学习记录
        updateLearnRecord({ endStatus = 0, playStatus = 0 }) {
            return new Promise((resolve, reject) => {
                const courseLessonUserStudy = this.learnRecord?.courseLessonUserStudy || {}
                courseLessonUserStudy.progress = this.playTime || 0 // 进度
                // eslint-disable-next-line eqeqeq
                if (endStatus == 1) courseLessonUserStudy.participationStatus = 1
                request({
                    ...API.updateMyStudyRecord,
                    data: {
                        id: this.learnRecord?.id,
                        courseId: this.learnRecord?.courseId,
                        courseLessonId: this.learnRecord?.courseLessonId,
                        endTime: this.playTime || 0,
                        courseLessonUserStudy,
                        playStatus,
                        key: this.learnRecord?.key
                    }
                })
                    .then((result) => {
                        if (result.code === 0) {
                            resolve()
                        } else {
                            reject(new Error('更新学习记录失败'))
                        }
                    })
                    .catch((error) => {
                        // 保留后端业务错误码，课程播放页需根据拍照前置条件决定是否补开拍照弹窗。
                        reject(error)
                    })
            })
        },

        // 记录学习，如果有 id 则更新，没有 id 则新增
        async recordStudy({ courseId, courseLessonId, startTime, endStatus = 0, playStatus = 0 }) {
            const hasRecord = this.learnRecord && this.learnRecord?.id
            if (hasRecord) {
                console.log(`>>>>>>>> 记录器正在工作ing，执行 update 学习记录，id 为 ${this.learnRecord?.courseLessonId}`)
                return await this.updateLearnRecord({ endStatus, playStatus })
            } else {
                console.log('>>>>>>>> 记录器正在工作ing，执行 create 学习记录，id 为 ', courseLessonId)
                return await this.createLearnRecord({ courseId, courseLessonId, startTime })
            }
        },

        // 清除培训记录
        clearTrainRecord() {
            this.$patch({ trainRecord: null })
            console.log('>>>>>>>> 清空培训记录', JSON.stringify(this.trainRecord))
        },

        // 创建培训学习记录
        createTrainLearnRecord({ sessionId, sessionLessonId, startTime }) {
            return new Promise((resolve, reject) => {
                request({
                    ...API.createTrainMyStudyRecord,
                    data: {
                        sessionId,
                        sessionLessonId,
                        startTime: startTime || 0
                    }
                })
                    .then(async (data) => {
                        this.$patch({ trainRecord: data.data })
                        resolve()
                    })
                    .catch((error) => {
                        // 保留后端业务错误码，培训播放页需据此识别“学习前拍照”前置条件。
                        reject(error)
                    })
            })
        },
        // 更新培训学习记录
        updateTrainLearnRecord({ endStatus = 0, playStatus = 0 }) {
            return new Promise((resolve, reject) => {
                const sessionLessonUserStudy = this.trainRecord?.sessionLessonUserStudy || {}
                sessionLessonUserStudy.progress = this.playTime || 0 // 进度
                // eslint-disable-next-line eqeqeq
                if (endStatus == 1) sessionLessonUserStudy.participationStatus = 1

                const { id, sessionId, sessionLessonId } = this.trainRecord
                if ([id, sessionId, sessionLessonId].includes('')) {
                    reject(new Error('请求参数不完整'))
                }
                request({
                    ...API.updateTrainMyStudyRecord,
                    data: {
                        id: this.trainRecord?.id,
                        sessionId: this.trainRecord?.sessionId,
                        sessionLessonId: this.trainRecord?.sessionLessonId,
                        endTime: this.playTime || 0,
                        sessionLessonUserStudy,
                        playStatus,
                        key: this.trainRecord?.key
                    }
                })
                    .then(() => resolve())
                    .catch((error) => reject(error))
            })
        },

        // 记录培训学习，如果有 id 则更新，没有 id 则新增
        async recordTrainStudy({ sessionId, sessionLessonId, startTime, endStatus = 0, playStatus = 0 }) {
            const hasRecord = this.trainRecord && this.trainRecord?.id
            console.log(this.trainRecord)
            if (hasRecord) {
                console.log(`>>>>>>>> 记录器正在工作ing，执行 update 培训记录，id 为 ${this.trainRecord?.sessionLessonId}`)
                return await this.updateTrainLearnRecord({ endStatus, playStatus })
            } else {
                console.log('>>>>>>>> 记录器正在工作ing，执行 create 培训记录，id 为 ', sessionLessonId)
                return await this.createTrainLearnRecord({ sessionId, sessionLessonId, startTime })
            }
        }
    }
})

export { useAppStore }
